// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath fill=%27%23333%27 d=%27M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --c-primary:        #5616ea;
    --c-primary-dark:   #4620c7;
    --c-grey-100:       #faf9ff;
    --c-grey-300:       #dbd9e4;
    --c-grey-600:       #555;
    --c-grey-800:       #333;
    --c-danger:         #dc3545;

    --r-s:              .5rem;
    --r-m:              .875rem;
    --shadow:           0 10px 24px rgba(0, 0, 0, .15);

    --sp-1:             .5rem;
    --sp-2:             .75rem;
    --sp-3:             1rem;
    --sp-4:             1.5rem;
    --sp-5:             2rem;
    --safe-top:         4rem;
    --safe-bottom:      35px;

    --swap-dur-out: 280ms;
    --swap-dur-in:  520ms;
    --swap-delay-in: 120ms;
}

@media (min-width: 768px) {
    :root {
        --sp-3: 1.125rem;
        --sp-4: 2rem;
        --sp-5: 2.75rem;
    }
}

/* Only the register flow + everything inside it */
.register-scope,
.register-scope *,
.register-scope *::before,
.register-scope *::after {
    box-sizing: border-box;
}

.register-scope {
    font-family: "DM Sans", sans-serif;
}

img {
    display: block;
    max-width: 100%;
}

.wrapper {
    height: 100vh;
    height: 100svh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--safe-top) var(--sp-4) var(--safe-bottom);
    background: linear-gradient(120deg, var(--c-primary) 0%, #320661 100%);
    position: relative;
}

.logo-register-site {
    position: fixed;
    z-index: 5;
    top: var(--sp-3);
    left: var(--sp-3);
    width: clamp(150px, 2vw, 50px);
}

.landing-footer-links {
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 25px;
}

.landing-footer-links a {
    color: white;
    font-size: 0.8125rem;
}


.step-ind {
    position: absolute;
    top: var(--sp-3);
    right: var(--sp-4);
    color: #ffffff;
    font-weight: 500;
    font-size: 0.9rem;
}

.steps-wrapper,
.steps-slider,
.step-slide {
    height: 100%;
}

.steps-wrapper {
    overflow: hidden;
    width: 100%;
}

/* Not a scroll container: a scrollIntoView inside a slide (the test chat
   scrolls to its last message) must never shift the slider sideways. Scoped,
   because WebflowStepsModal.css also styles .steps-wrapper globally. */
.register-scope .steps-wrapper {
    overflow: clip;
}

.steps-slider {
    display: flex;
    width: 100%;
    transition: transform 0.5s ease;
}

.step-slide {
    flex: 0 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline: var(--sp-3);
}

.card-button-wrapper,
.chatbot-card,
.preview-parent-container,
.subscription-section {
    max-height: calc(100svh - var(--safe-top) - var(--safe-bottom) - 2 * var(--sp-4));
    overflow: auto;
    text-align: center;
}

.card,
.chatbot-card,
.preview-parent-container {
    background: #ffffff;
    border-radius: var(--r-m);
    box-shadow: var(--shadow);
}

.card {
    width: min(100%, 480px);
    padding: 25px;
    text-align: center;
}

.card.building {
    position: relative;
    background-color: x#e1e5eb;
    opacity: 0.95;
    overflow: hidden;
}

.card.building::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
        transparent 0deg,
        transparent 160deg,
        rgba(94, 27, 255, 0.2) 190deg,
        rgba(94, 27, 255, 0.5) 210deg,
        #5616ea 230deg,
        #9966ff 295deg,
        #5d1cff 360deg
    );
    transform: translate(-50%, -50%);
    animation: rotateBorder 3s linear infinite;
    z-index: 0;
}

.card.building::after {
    content: '';
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    background: #ffffff;
    border-radius: calc(var(--r-m) - 6px);
    z-index: 0;
}

.card.building > * {
    position: relative;
    z-index: 1;
}

@keyframes rotateBorder {
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

.lawyer-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: var(--r-m);
    box-shadow: var(--shadow);
    width: min(100%, 480px);
    padding: 25px;
    text-align: center;
    gap: 10px;
}

.chatbot-card {
    width: min(100%, 620px);
    padding: var(--sp-4) var(--sp-3);
    padding-top: 18px;
    padding-bottom: 15px;
}

.chatbot-card {
    display: flex;
    flex-direction: column;
}

/* .chat-parent {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
} */

.preview-parent-container {
    width: 100%;
    max-width: 1000px;
    padding: var(--sp-4) var(--sp-3);
    padding-top: 18px;
    display: flex;
    flex-direction: column;
    gap: var(--sp-4);
}

.card-button-wrapper {
    width: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.btn {
    width: 100%;
    max-width: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    padding: 0.85em 1.5em;
    font-weight: 600;
    font-size: 1.0625rem;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #6a00f4, #9d00ff);
    color: #fff;
    box-shadow: 0 6px 20px rgba(154, 0, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.4);
    outline: none;
}

.btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(154, 0, 255, 0.45);
    background: linear-gradient(135deg, #7500d4, #6a6a6a);
}

.btn:disabled {
    background: #7e868e;
    cursor: not-allowed;
}

.integration-button-link {
  font-weight: 700;
  font-family: inherit;
  appearance: none;
  border: 2px solid #5616ea;
  background: #fff;
  color: #5616ea;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.125rem;
  transition: 0.2s ease, color 0.2s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.integration-button-link:hover {
  background: #f5f5f5;
  transform: translateY(-1.5px);
}

h2 {
    margin: 0 0 var(--sp-3);
    font-size: clamp(1.3rem, 2.3vw + 1rem, 2.1rem);
    font-weight: 700;
    line-height: 1.2;
}

.sub {
    font-size: clamp(0.9rem, 1vw + 0.75rem, 1.05rem);
    margin: 0 0 var(--sp-4);
    color: var(--c-grey-600);
}

.register-input-text {
    width: 100%;
    padding: var(--sp-3);
    margin-bottom: var(--sp-3);
    font-size: 1rem;
    font-weight: 600;
    color: #000000;
    border: 1px solid #ced4da;
    border-radius: var(--r-s);
}

.register-input-text:disabled {
    cursor: not-allowed;
}

.register-input-text:focus {
    border-color: var(--c-primary);
    outline: none;
    box-shadow: 0 0 0 3px #5616ea33;
}

.input-error {
    border-color: var(--c-danger) !important;
}

.privacy-note {
    font-size: 0.8rem;
    color: var(--c-grey-800);
    font-style: italic;
}

.spin {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    border: 2px solid #ffffff;
    border-top-color: var(--c-primary);
    animation: spin 1s linear infinite;
}

.err {
    margin-top: var(--sp-3);
    color: var(--c-danger);
    font-weight: 600;
}

/* Webflow onboarding: a plain status line (code sent, account exists, slow
   build) and links that are buttons (keyboard reachable). */
.wf-notice {
    margin-top: var(--sp-3);
    color: var(--c-grey-600);
    line-height: 1.45;
}

.wf-link {
    background: none;
    border: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
}

.wf-link:disabled {
    opacity: 0.6;
    cursor: default;
}

.wf-link:focus-visible {
    outline: 2px solid #5616ea;
    outline-offset: 2px;
    border-radius: 2px;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.preview-area {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
}

.preview-header-text {
    text-align: center;
}

.preview-card {
    display: flex;
    justify-content: space-between;
    gap: var(--sp-4);
}

.user-settings {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
}

.user-settings input[type="color"] {
    appearance: none;
    width: 34px;
    height: 34px;
    border-radius: 20%;
    padding: 2px;
    border: 1px solid var(--c-grey-300);
    cursor: pointer;
    background: none;
    transition: transform 0.3s;
}

.user-settings input[type="color"]:hover {
    transform: scale(1.12);
}

.user-settings input[type="color"]::-webkit-color-swatch {
    border: 0;
    border-radius: 20%;
}

.user-settings input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    height: 6px;
    background: #dddddd;
    border-radius: 3px;
    margin-top: 0.4rem;
}

.user-settings input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--c-primary);
    cursor: pointer;
    -webkit-transition: background 0.3s, transform 0.3s;
    transition: background 0.3s, transform 0.3s;
}

.user-settings input[type="range"]::-webkit-slider-thumb:hover {
    background: var(--c-primary-dark);
    transform: scale(1.1);
}

.subscription-section {
    text-align: center;
    max-width: 1100px;
    margin: 0 auto;
    padding: var(--sp-4) var(--sp-3);
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 15px;
    background: linear-gradient(to right, #ffffff, var(--c-grey-100));
    border-radius: var(--r-m);
}

.plan-slider-wrapper {
    padding-inline: var(--sp-2);
    padding-top: 18px;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
}

.plan-slider-wrapper::-webkit-scrollbar {
    height: 8px;
}

.plan-slider-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.plan-slider-wrapper::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    border-radius: 4px;
}

.plan-slider-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
}

@media (max-width: 480px) {
    .plan-slider-wrapper::-webkit-scrollbar {
        height: 0;
    }
}

.plan-slider {
    display: flex;
    gap: var(--sp-3);
    width: max-content;
}

.plan-card {
    flex: 0 0 280px;
    min-width: 280px;
    scroll-snap-align: center;
    background: #ffffff;
    border: 2px solid #bdb4f1;
    border-radius: var(--r-m);
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: var(--sp-3) var(--sp-3);
    transition: transform 0.3s, box-shadow 0.3s;
    box-shadow: none;
    margin-bottom: 10px;
    position: relative;
}

.plan-badge {
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    background: #5616ea;
    color: #ffffff;
    padding: 6px 12px;
    font-size: 0.90rem;
    font-weight: 600;
    line-height: 1;
    border-radius: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    white-space: nowrap;
}

.plan-card h3 {
    margin: 0 0 var(--sp-2);
    font-size: clamp(1.25rem, 1vw + 1rem, 1.7rem);
    color: var(--c-primary);
}

.plan-price {
    font-weight: 700;
    margin: 0px;
    font-size: 1.5rem;
}

.plan-price-month {
  margin: 0;
  font-size: 0.9rem;
  color: #555;
  font-style: italic;
}

.plan-description {
    margin: 0;
    font-size: 0.95rem;
    color: var(--c-grey-600);
    font-style: italic;
    color: #5616ea;
    margin-bottom: 5px;
    font-weight: 600;
}

.plan-features {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-bottom: 0.2rem;
}

.plan-features li {
    font-size: 1rem;
    margin-bottom: 0.8rem;
    color: #333;
}

.plan-features svg {
    margin-bottom: -0.5px;
}

.plan-icons-included {
    margin-right: 0.5rem;
    color: #5616ea;
}

.plan-icons-not-included {
    margin-right: 0.5rem;
    color: #e51616;
}

.feature-platform-icon {
    height: 18px;
    width: auto;
    margin-left: 10px;
    vertical-align: middle;
    position: relative;
    top: 1px;
    object-fit: contain;
}

/* ─── Custom Tooltip Styles ──────────────────────────────────────────*/
.icon-tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}

.icon-tooltip-wrapper .feature-platform-icon {
    transition: transform 0.2s ease, filter 0.2s ease;
}

.icon-tooltip-wrapper:hover .feature-platform-icon {
    transform: scale(1.15) translateY(-2px);
    filter: drop-shadow(0 4px 8px rgba(86, 22, 234, 0.25));
}

.icon-tooltip {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%) translateY(8px);
    padding: 10px 14px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: #ffffff;
    font-size: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
    border-radius: 10px;
    box-shadow: 
        0 10px 40px rgba(0, 0, 0, 0.25),
        0 0 0 1px rgba(255, 255, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    opacity: 0;
    visibility: hidden;
    transition: 
        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        visibility 0.3s;
    z-index: 100;
    pointer-events: none;
    backdrop-filter: blur(10px);
    letter-spacing: 0.3px;
}

.icon-tooltip::before {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, transparent 50%, #16213e 50%);
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 3px 0;
}

.icon-tooltip-wrapper:hover .icon-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
}

/* Tooltip color variants */
.icon-tooltip.facebook {
    background: linear-gradient(135deg, #1877f2 0%, #0d65d9 100%);
}
.icon-tooltip.facebook::before {
    background: linear-gradient(135deg, transparent 50%, #0d65d9 50%);
}

.icon-tooltip.instagram {
    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}
.icon-tooltip.instagram::before {
    background: linear-gradient(135deg, transparent 50%, #bc1888 50%);
}

.icon-tooltip.whatsapp {
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
}
.icon-tooltip.whatsapp::before {
    background: linear-gradient(135deg, transparent 50%, #128c7e 50%);
}

.icon-tooltip.google-drive {
    background: linear-gradient(135deg, #4285f4 0%, #34a853 50%, #fbbc05 100%);
}
.icon-tooltip.google-drive::before {
    background: linear-gradient(135deg, transparent 50%, #fbbc05 50%);
}

.icon-tooltip.onedrive {
    background: linear-gradient(135deg, #0078d4 0%, #005a9e 100%);
}
.icon-tooltip.onedrive::before {
    background: linear-gradient(135deg, transparent 50%, #005a9e 50%);
}

.wix-plan-button {
    width: 100%;
    gap: 0.5em;
    padding: 0.65em 1.5em;
    font-weight: 600;
    font-size: 18px;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);
    color: #fff;
    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.4);
    text-align: center;
    position: relative;
    z-index: 1;
}

.wix-plan-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
    pointer-events: none;
}

.wix-plan-button:hover:not(:disabled)::before {
    opacity: 1;
}

.wix-plan-button:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);
}

.wix-plan-button:disabled {
    background: #7e868e;
    cursor: not-allowed;
}

.pricing-indicators {
    display: flex;
    justify-content: center;
    gap: var(--sp-2);
    margin-top: var(--sp-4);
}

.indicator {
    width: 40px;
    height: 8px;
    border: 1px solid var(--c-grey-300);
    border-radius: var(--r-s);
    background: transparent;
    transition: background 0.3s, border-color 0.3s;
}

.indicator.active {
    background: var(--c-primary);
    border-color: var(--c-primary);
}

.wf-pricing-indicators {
    display: flex;
    justify-content: center;
    gap: var(--sp-2);
    margin-top: var(--sp-4);
}

.wf-indicator {
    width: 40px;
    height: 8px;
    border: 1px solid var(--c-grey-300);
    border-radius: var(--r-s);
    background: transparent;
    transition: background 0.3s, border-color 0.3s;
    cursor: pointer;
}

.wf-indicator.active {
    background: var(--c-primary);
    border-color: var(--c-primary);
}

@media (min-width: 920px) {
    .wf-pricing-indicators {
        display: none;
    }
}

.cancel-note {
    font-size: 0.85rem;
    color: var(--c-grey-600);
    margin-top: 15px;
    padding-inline: var(--sp-2);
}

.billing-toggle {
  position: relative;
  display: inline-flex;
  border: 1px solid #dddddd;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f1f1;
  padding: 4px;
  outline: none;
}

.billing-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(50% - 3px);
  height: calc(100% - 6px);
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  z-index: 0;
}

.billing-toggle[data-cycle="YEAR"] .billing-thumb {
  left: 50%;
}

.billing-toggle button {
  position: relative;
  z-index: 1;
  flex: 1 1;
  padding: 5px 20px;
  padding-top: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #969696;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  text-align: center;
}

.billing-toggle button.active {
  color: #2f2f2f;
}

@media (min-width: 920px) {
    .plan-slider-wrapper {
        overflow: visible;
        padding: 0;
        padding-top: 18px;
    }

    .plan-slider {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(3, 1fr);
        gap: var(--sp-4);
    }

    .plan-card {
        flex: 0 0 auto;
        min-width: unset;
        max-width: 100%;
        scroll-snap-align: unset;
    }

    .pricing-indicators {
        display: none;
    }
}

.complete-title {
    border-bottom: 1px solid var(--c-grey-300);
    padding-bottom: 20px;
    font-size: 1.5rem;
}

.live-highlight {
    background: var(--c-primary);
    color: #ffffff;
    border-radius: 1rem;
    font: 600 clamp(1rem, 3vw + 0.4rem, 1.4rem) / 1 inherit;
    padding: 12px;
    padding-top: 3px;
    padding-bottom: 8px;
}

.portal-button-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.divider {
  width: 0.5px;
  background-color: #ccc;
}

.custom-url-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 1rem;
  font-weight: 600;
  border: 1px solid #7b7b7b;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  background-color: white;
  color: #333;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.custom-url-input:focus {
  border-color: #5616ea;
  box-shadow: 0 0 0 3px rgba(94, 27, 255, 0.15);
}

.custom-url-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.url-arrow-down {
    font-size: 30px;
    margin-bottom: 15px;
    color: #5616ea;
}

.color-picker-container {
    justify-content: space-between;
}

.border-radius-container {
    justify-content: space-between;
}

.onboarding-widget-close-button {
  font-size: 0.9375rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  margin: 0;
  padding: 0;
  outline: none;
  transition: all 0.3s ease;
}

.onboarding-widget-close-button:hover {
  transform: translateY(-1px);
}

.onboarding-send-message {
  padding: 10px !important;
  padding-left: 13px !important;
  padding-right: 13px !important;
  margin-left: 5px !important;
}

.message-container .bot-message {
    text-align: left;
}

.chat-body {
    text-align: left;
}

.after-setup-links {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.integration-complete-content {
    display: flex;
    gap: 8px;
    justify-content: center;
    font-size: 1.125rem;
    font-weight: 600;
    align-items: center;
}

/* ─── reusable back arrow ──────────────────────────────────────────*/
.header-back-button {
  position: relative;
  text-align: center;
  margin-bottom: 15px;
  /* Room for the back button on both sides: a long title stays centred and
     never runs under it on a phone. */
  padding-inline: 38px;
}

.lp-back-btn {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);
  border: none;
  outline: none;
  border-radius: 50%;
  font-size: 1.125rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
  transition: transform .25s, box-shadow .25s;
}

.lp-back-btn:hover {
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,.16);
}

.lp-back-btn:active {
  transform: translateY(-50%) translateX(0);
  box-shadow: 0 3px 8px rgba(0,0,0,.12);
}

.header-back-button h2 {
  margin: 0;
  font-size: 1.25rem;
}

.select {
  padding: 10px 30px 10px 10px;
  border: 2px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s, box-shadow 0.3s;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
}

.select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}

.input-error {
  border-color: #e74c3c;
}

.select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  color: #999;
}

.footer-cancel-info {
    color: white;
    margin: 0;
    font-size: 0.75rem;
    font-weight: 600;
    margin-top: 5px;
}

.lawyer-footer-cancel-info {
    color: rgb(0, 0, 0);
    margin: 0;
    font-size: 0.75rem;
    font-weight: 600;
    margin-top: -4px;
}

.chatbot-loading-container {
    display: flex;
    flex-direction: column;
    color: #5616ea;
    font-weight: 600;
    font-size: 1.1rem;
    margin-top: 10px;
}

.wix-price-month-container {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.wix-plan-price {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
}

.wix-plan-month {
    margin: 0;
    font-size: 13px;
    color: grey;
    margin-top: 2px;
    font-style: italic;
}

@media (max-width: 480px) {
    .preview-card {
        flex-direction: column;
    }

    .wrapper {
        padding: var(--safe-top) var(--sp-3) var(--safe-bottom);
    }

    .card {
        padding: var(--sp-3) var(--sp-3);
    }

    .chatbot-card {
        padding: var(--sp-3) var(--sp-2);
    }

    .preview-parent-container {
        padding: var(--sp-3) var(--sp-2);
    }

    .plan-card {
        flex: 0 0 260px;
        min-width: 260px;
    }

    .plan-card p {
        margin: 2px;
    }

    .plan-card h3 {
        margin: 0;
        font-size: 1.5rem;
    }

    .plan-card:hover {
        transform: translateY(0px);
        box-shadow: none !important;
    }

    .cancel-note {
        margin: 0;
        margin-top: 20px;
    }

    .divider {
        width: 100%;
        height: 1px;
        background-color: #ccc;
    }

    .btn {
        max-width: 450px;
        font-size: 1.1875rem;
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .live-highlight {
        padding: 0.25em 0.6em;
    }

    .header-back-button {
        margin-bottom: 18px;
    }

    .landing-footer-links {
        gap: 20px;
        bottom: 14px;
    }

    .landing-footer-links a {
        font-size: 0.75rem;
    }
    .card-button-wrapper,
    .chatbot-card,
    .preview-parent-container,
    .subscription-section {
        max-height: calc(100svh - var(--safe-top) - 2 * var(--sp-3));
        max-height: calc(100svh - var(--safe-top) - var(--safe-bottom) - 2 * var(--sp-3));
    }

    .logo-register-site {
        width: clamp(80px, 2vw, 50px);
    }

}

.trust-slide{
  text-align:center;
  display:flex;
  flex-direction:column;
  gap:18px;
}

.trust-slide h2 {
  font-size: 26px;
}

.carousel{
  position:relative;
  overflow:hidden;
  touch-action: pan-y;
  user-select:none;
  -webkit-user-select:none;
}

.carousel-track{
  display:flex;
  transition:transform .6s ease;
  align-items:stretch;
}

.slide{
  flex:0 0 100%;
  display:flex;
}

.slide-content.review-card{
  margin: 10px 44px;
  flex:1 1 auto;
  display:flex;
  flex-direction:column;
  gap:15px;
  background:#f8f8f8;
  border:1px solid #5616ea;
  border-radius:10px;
  padding:20px 24px 16px;
  box-shadow: 2px 2px 10px rgba(63, 2, 99, 0.2);
}

.review-text{
  font-style:italic;
  font-size:1.1rem;
  line-height:1.45;
  color:#1a1a1a;
  margin: 0;
}

.review-footer{
  margin-top:auto;
  display:flex;
  flex-direction:column;
  align-items: center;
  gap:10px;
}

.review-author{
  font-weight:600;
  font-size:.9rem;
  color:#000;
  line-height:1.35;
  margin: 0;
  margin-bottom: 0.2rem;
}

.live-btn{
  background:#5616ea;
  color:#fff;
  padding:7px 16px;
  font-size:.90rem;
  font-weight:500;
  border-radius:6px;
  text-decoration:none;
  transition:background .2s ease, transform .2s ease;
  margin: 0;
  text-align: center;
  outline: none;
  cursor: pointer;
  border: none;
}

.live-btn:hover{
  background:#4b16d1;
  transform:translateY(-1px);
}

.carousel-nav{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  width:36px;
  height:36px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:#fff;
  border:1px solid rgba(0,0,0,.2);
  border-radius:50%;
  box-shadow:0 1px 3px rgba(0,0,0,.07);
  color:#5616ea;
  cursor:pointer;
}

.carousel-nav.prev{
  left:0;
}

.carousel-nav.next{
  right:0;
}

.carousel-dots{
  display:flex;
  justify-content:center;
  gap:6px;
}

.dot{
  width:8px;
  height:8px;
  border-radius:50%;
  background:#d6d6ff;
  cursor:pointer;
}

.dot.active{
  background:#5616ea;
}

.trust-extras{
  display:flex;
  justify-content:center;
  margin: 0.5rem;
}

.badges-wrapper{
  display:flex;
}

.badges{
  list-style:none;
  display:flex;
  flex-direction:column;
  gap:6px;
  padding:0;
  margin:0;
  font-size:.92rem;
}

.badges li{
  display:flex;
  align-items:center;
  gap:8px;
}

.rating-stars {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-size: 9px;
    color: #5616ea;
}

.yearly-crossout{
  display: flex;
  align-items: center;
  gap: 12px;
}

.yearly-crossout .old-price {
  text-decoration: line-through;
  text-decoration-thickness: 1.5px;
  text-decoration-color: #5616ea;
  opacity: .8;
  font-size: 18px;
}

.yearly-crossout .arrow{
  opacity: .6;
}

.yearly-crossout .new-price{
  font-weight:800;
}

.yearly-crossout .deal-tag {
  display: flex;
  align-items: center;
  padding: 7px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: .75rem;
  font-weight: 700;
  border-radius: 10px;
  background: #5616ea;
  color: white;
  border: none;
  text-align: center;
  height: 80%;
}

.free-plan-link {
    margin: 0;
}

.free-plan-link-button {
  background: none;
  border: none;
  color: #5616ea;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
  text-decoration: underline;
  margin: 0;
}

.free-plan-link-button:hover {
  opacity: 0.8;
}


@media(max-width:480px){
  .slide-content.review-card{ margin-bottom:12px 40px; }
  .carousel-nav{ width:32px; height:32px; }
  .review-text{ font-size:1.0rem; }
  .review-author{ font-size:.82rem; }
  .live-btn{ font-size:.78rem; padding:6px 14px; }
}

/* ── Price cross-fade + slide (slower + staggered) ─────────────────── */
.price-swap {
  position: relative;
  min-height: 60px; /* a touch taller to avoid jumps; tweak if needed */
  will-change: opacity, transform;
}

.price-swap .pane {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: translateY(8px);
  transition:
    opacity var(--swap-dur-out) cubic-bezier(.22,.7,.18,1),
    transform var(--swap-dur-out) cubic-bezier(.22,.7,.18,1);
  pointer-events: none;
}

.price-swap .pane.show {
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity var(--swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--swap-delay-in),
    transform var(--swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--swap-delay-in);
  pointer-events: auto;
}

/* Deal tag pops in a hair after the content starts */
.price-swap .pane .deal-tag {
  transform: scale(.94);
  opacity: 0;
  transition:
    transform 260ms cubic-bezier(.22,.7,.18,1) calc(var(--swap-delay-in) + 80ms),
    opacity 260ms cubic-bezier(.22,.7,.18,1)   calc(var(--swap-delay-in) + 80ms);
}

.price-swap .pane.show .deal-tag {
  transform: scale(1);
  opacity: 1;
}

/* Old price fades in gently */
.price-swap .pane .old-price {
  opacity: 0;
  transition: opacity 280ms ease calc(var(--swap-delay-in) + 60ms);
}
.price-swap .pane.show .old-price {
  opacity: .9;
}

.start-website-hint-text {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 12px;
  margin-top: 0.5rem;
  color: #5616ea;
  font-weight: 600;
}

.start-website-hint-text p {
  margin: 0;
  padding: 0;
}


/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .price-swap .pane,
  .price-swap .pane.show,
  .price-swap .pane .deal-tag,
  .price-swap .pane .old-price {
    transition: none !important;
    transform: none !important;
    opacity: 1 !important;
  }
}

/* Webflow onboarding: "Add to my site" is its own step (#1197336), a card like
   Welcome and Create, then the publish notice inside it. */
.card.wf-add-step {
    width: min(100%, 520px);
    box-sizing: border-box;
}
.wf-add-step .sub {
    margin-bottom: var(--sp-3);
}
.wf-add-step__site {
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto var(--sp-4);
    padding: 6px 14px;
    border-radius: 999px;
    background: #f3effe;
    color: #2b2140;
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;
}
/* An action inside the card, not the wizard's Continue: the back button's
   deep purple, compact. */
.wf-add-step__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0 auto;
    padding: 10px 22px;
    border: none;
    border-radius: 10px;
    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);
    color: #fff;
    font: inherit;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .12);
    transition: transform .25s, box-shadow .25s;
}
.wf-add-step__btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, .16);
}
.wf-add-step__btn:disabled {
    opacity: .6;
    cursor: default;
}
.wf-add-step__done {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0 0 var(--sp-3);
    color: #1f9d55;
    font-weight: 600;
}
.wf-add-step .wf-publish-notice {
    margin: 0;
    max-width: none;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LandingPageRegister.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;;IAE3B,yBAAyB;IACzB,2BAA2B;IAC3B,kDAAkD;;IAElD,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;IACxB,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA,kDAAkD;AAClD;;;;IAII,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uDAAuD;IACvD,sEAAsE;IACtE,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;uEAEuE;AACvE;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;;;;IAII,iFAAiF;IACjF,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ;;;;;;;;KAQC;IACD,gCAAgC;IAChC,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,6CAA6C;IACjD;IACA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;GAIG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,qDAAqD;IACrD,WAAW;IACX,6CAA6C;IAC7C,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;4DAC4D;AAC5D;IACI,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,mDAA2C;IAA3C,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,iEAAiE;IACjE,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;IAChC,2CAA2C;IAC3C,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,6CAA6C;IAC7C,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;AACvB;;AAEA,wEAAwE;AACxE;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,uCAAuC;IACvC,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,2CAA2C;IAC3C,kBAAkB;IAClB,6DAA6D;IAC7D,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB;;;8CAG0C;IAC1C,UAAU;IACV,kBAAkB;IAClB;;;uBAGmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,iEAAiE;IACjE,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,2BAA2B;AAC3B;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,oGAAoG;AACxG;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,0EAA0E;AAC9E;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,6DAA6D;AACjE;AACA;IACI,iEAAiE;AACrE;;AAEA;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,qDAAqD;IACrD,mEAAmE;IACnE,WAAW;IACX,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,mEAAmE;IACnE,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,uBAAuB;IACvB,8CAA8C;AAClD;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,uBAAuB;IACvB,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kDAAkD;EAClD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mDAAmD;EACnD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;IACnB,uDAAuD;IACvD,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB;sCACoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mEAAmE;EACnE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,WAAW;EACX,sBAAsB;EAGtB,gBAAgB;EAChB,yDAAiN;EACjN,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uDAAuD;IAC3D;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;IACA;;;;QAII,4DAA4D;QAC5D,iFAAiF;IACrF;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;EAClD,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;AACT;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,4BAA4B,uBAAuB,EAAE;EACrD,eAAe,UAAU,EAAE,WAAW,EAAE;EACxC,cAAc,gBAAgB,EAAE;EAChC,gBAAgB,gBAAgB,EAAE;EAClC,WAAW,gBAAgB,EAAE,gBAAgB,EAAE;AACjD;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,gBAAgB,EAAE,mDAAmD;EACrE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0BAA0B;EAC1B;;4DAE0D;EAC1D,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;;gFAE8E;EAC9E,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;EACrB,UAAU;EACV;;gFAE8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,gEAAgE;AAClE;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;;AAGA,2BAA2B;AAC3B;EACE;;;;IAIE,2BAA2B;IAC3B,0BAA0B;IAC1B,qBAAqB;EACvB;AACF;;AAEA;2DAC2D;AAC3D;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;0BAC0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,mEAAmE;IACnE,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,2CAA2C;AAC/C;AACA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[":root {\n    --c-primary:        #5616ea;\n    --c-primary-dark:   #4620c7;\n    --c-grey-100:       #faf9ff;\n    --c-grey-300:       #dbd9e4;\n    --c-grey-600:       #555;\n    --c-grey-800:       #333;\n    --c-danger:         #dc3545;\n\n    --r-s:              .5rem;\n    --r-m:              .875rem;\n    --shadow:           0 10px 24px rgba(0, 0, 0, .15);\n\n    --sp-1:             .5rem;\n    --sp-2:             .75rem;\n    --sp-3:             1rem;\n    --sp-4:             1.5rem;\n    --sp-5:             2rem;\n    --safe-top:         4rem;\n    --safe-bottom:      35px;\n\n    --swap-dur-out: 280ms;\n    --swap-dur-in:  520ms;\n    --swap-delay-in: 120ms;\n}\n\n@media (min-width: 768px) {\n    :root {\n        --sp-3: 1.125rem;\n        --sp-4: 2rem;\n        --sp-5: 2.75rem;\n    }\n}\n\n/* Only the register flow + everything inside it */\n.register-scope,\n.register-scope *,\n.register-scope *::before,\n.register-scope *::after {\n    box-sizing: border-box;\n}\n\n.register-scope {\n    font-family: \"DM Sans\", sans-serif;\n}\n\nimg {\n    display: block;\n    max-width: 100%;\n}\n\n.wrapper {\n    height: 100vh;\n    height: 100svh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: var(--safe-top) var(--sp-4) var(--safe-bottom);\n    background: linear-gradient(120deg, var(--c-primary) 0%, #320661 100%);\n    position: relative;\n}\n\n.logo-register-site {\n    position: fixed;\n    z-index: 5;\n    top: var(--sp-3);\n    left: var(--sp-3);\n    width: clamp(150px, 2vw, 50px);\n}\n\n.landing-footer-links {\n    position: fixed;\n    bottom: 15px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 5;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    gap: 25px;\n}\n\n.landing-footer-links a {\n    color: white;\n    font-size: 0.8125rem;\n}\n\n\n.step-ind {\n    position: absolute;\n    top: var(--sp-3);\n    right: var(--sp-4);\n    color: #ffffff;\n    font-weight: 500;\n    font-size: 0.9rem;\n}\n\n.steps-wrapper,\n.steps-slider,\n.step-slide {\n    height: 100%;\n}\n\n.steps-wrapper {\n    overflow: hidden;\n    width: 100%;\n}\n\n/* Not a scroll container: a scrollIntoView inside a slide (the test chat\n   scrolls to its last message) must never shift the slider sideways. Scoped,\n   because WebflowStepsModal.css also styles .steps-wrapper globally. */\n.register-scope .steps-wrapper {\n    overflow: clip;\n}\n\n.steps-slider {\n    display: flex;\n    width: 100%;\n    transition: transform 0.5s ease;\n}\n\n.step-slide {\n    flex: 0 0 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-inline: var(--sp-3);\n}\n\n.card-button-wrapper,\n.chatbot-card,\n.preview-parent-container,\n.subscription-section {\n    max-height: calc(100svh - var(--safe-top) - var(--safe-bottom) - 2 * var(--sp-4));\n    overflow: auto;\n    text-align: center;\n}\n\n.card,\n.chatbot-card,\n.preview-parent-container {\n    background: #ffffff;\n    border-radius: var(--r-m);\n    box-shadow: var(--shadow);\n}\n\n.card {\n    width: min(100%, 480px);\n    padding: 25px;\n    text-align: center;\n}\n\n.card.building {\n    position: relative;\n    background-color: x#e1e5eb;\n    opacity: 0.95;\n    overflow: hidden;\n}\n\n.card.building::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 200%;\n    height: 200%;\n    background: conic-gradient(\n        transparent 0deg,\n        transparent 160deg,\n        rgba(94, 27, 255, 0.2) 190deg,\n        rgba(94, 27, 255, 0.5) 210deg,\n        #5616ea 230deg,\n        #9966ff 295deg,\n        #5d1cff 360deg\n    );\n    transform: translate(-50%, -50%);\n    animation: rotateBorder 3s linear infinite;\n    z-index: 0;\n}\n\n.card.building::after {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    right: 8px;\n    bottom: 8px;\n    background: #ffffff;\n    border-radius: calc(var(--r-m) - 6px);\n    z-index: 0;\n}\n\n.card.building > * {\n    position: relative;\n    z-index: 1;\n}\n\n@keyframes rotateBorder {\n    from {\n        transform: translate(-50%, -50%) rotate(0deg);\n    }\n    to {\n        transform: translate(-50%, -50%) rotate(360deg);\n    }\n}\n\n.lawyer-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: #ffffff;\n    border-radius: var(--r-m);\n    box-shadow: var(--shadow);\n    width: min(100%, 480px);\n    padding: 25px;\n    text-align: center;\n    gap: 10px;\n}\n\n.chatbot-card {\n    width: min(100%, 620px);\n    padding: var(--sp-4) var(--sp-3);\n    padding-top: 18px;\n    padding-bottom: 15px;\n}\n\n.chatbot-card {\n    display: flex;\n    flex-direction: column;\n}\n\n/* .chat-parent {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n} */\n\n.preview-parent-container {\n    width: 100%;\n    max-width: 1000px;\n    padding: var(--sp-4) var(--sp-3);\n    padding-top: 18px;\n    display: flex;\n    flex-direction: column;\n    gap: var(--sp-4);\n}\n\n.card-button-wrapper {\n    width: 100%;\n    max-width: 800px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n.btn {\n    width: 100%;\n    max-width: 350px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5em;\n    padding: 0.85em 1.5em;\n    font-weight: 600;\n    font-size: 1.0625rem;\n    border-radius: 12px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.3s ease;\n    background: linear-gradient(135deg, #6a00f4, #9d00ff);\n    color: #fff;\n    box-shadow: 0 6px 20px rgba(154, 0, 255, 0.3);\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    outline: none;\n}\n\n.btn:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(154, 0, 255, 0.45);\n    background: linear-gradient(135deg, #7500d4, #6a6a6a);\n}\n\n.btn:disabled {\n    background: #7e868e;\n    cursor: not-allowed;\n}\n\n.integration-button-link {\n  font-weight: 700;\n  font-family: inherit;\n  appearance: none;\n  border: 2px solid #5616ea;\n  background: #fff;\n  color: #5616ea;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1.125rem;\n  transition: 0.2s ease, color 0.2s ease;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.integration-button-link:hover {\n  background: #f5f5f5;\n  transform: translateY(-1.5px);\n}\n\nh2 {\n    margin: 0 0 var(--sp-3);\n    font-size: clamp(1.3rem, 2.3vw + 1rem, 2.1rem);\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.sub {\n    font-size: clamp(0.9rem, 1vw + 0.75rem, 1.05rem);\n    margin: 0 0 var(--sp-4);\n    color: var(--c-grey-600);\n}\n\n.register-input-text {\n    width: 100%;\n    padding: var(--sp-3);\n    margin-bottom: var(--sp-3);\n    font-size: 1rem;\n    font-weight: 600;\n    color: #000000;\n    border: 1px solid #ced4da;\n    border-radius: var(--r-s);\n}\n\n.register-input-text:disabled {\n    cursor: not-allowed;\n}\n\n.register-input-text:focus {\n    border-color: var(--c-primary);\n    outline: none;\n    box-shadow: 0 0 0 3px #5616ea33;\n}\n\n.input-error {\n    border-color: var(--c-danger) !important;\n}\n\n.privacy-note {\n    font-size: 0.8rem;\n    color: var(--c-grey-800);\n    font-style: italic;\n}\n\n.spin {\n    width: 1.2rem;\n    height: 1.2rem;\n    border-radius: 50%;\n    border: 2px solid #ffffff;\n    border-top-color: var(--c-primary);\n    animation: spin 1s linear infinite;\n}\n\n.err {\n    margin-top: var(--sp-3);\n    color: var(--c-danger);\n    font-weight: 600;\n}\n\n/* Webflow onboarding: a plain status line (code sent, account exists, slow\n   build) and links that are buttons (keyboard reachable). */\n.wf-notice {\n    margin-top: var(--sp-3);\n    color: var(--c-grey-600);\n    line-height: 1.45;\n}\n\n.wf-link {\n    background: none;\n    border: 0;\n    padding: 0;\n    font: inherit;\n    color: inherit;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.wf-link:disabled {\n    opacity: 0.6;\n    cursor: default;\n}\n\n.wf-link:focus-visible {\n    outline: 2px solid #5616ea;\n    outline-offset: 2px;\n    border-radius: 2px;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n.preview-area {\n  display: flex;\n  justify-content: flex-start;\n  gap: 20px;\n}\n\n.preview-header-text {\n    text-align: center;\n}\n\n.preview-card {\n    display: flex;\n    justify-content: space-between;\n    gap: var(--sp-4);\n}\n\n.user-settings {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.user-settings input[type=\"color\"] {\n    appearance: none;\n    width: 34px;\n    height: 34px;\n    border-radius: 20%;\n    padding: 2px;\n    border: 1px solid var(--c-grey-300);\n    cursor: pointer;\n    background: none;\n    transition: transform 0.3s;\n}\n\n.user-settings input[type=\"color\"]:hover {\n    transform: scale(1.12);\n}\n\n.user-settings input[type=\"color\"]::-webkit-color-swatch {\n    border: 0;\n    border-radius: 20%;\n}\n\n.user-settings input[type=\"range\"] {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 6px;\n    background: #dddddd;\n    border-radius: 3px;\n    margin-top: 0.4rem;\n}\n\n.user-settings input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: var(--c-primary);\n    cursor: pointer;\n    transition: background 0.3s, transform 0.3s;\n}\n\n.user-settings input[type=\"range\"]::-webkit-slider-thumb:hover {\n    background: var(--c-primary-dark);\n    transform: scale(1.1);\n}\n\n.subscription-section {\n    text-align: center;\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: var(--sp-4) var(--sp-3);\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 15px;\n    background: linear-gradient(to right, #ffffff, var(--c-grey-100));\n    border-radius: var(--r-m);\n}\n\n.plan-slider-wrapper {\n    padding-inline: var(--sp-2);\n    padding-top: 18px;\n    overflow-x: auto;\n    overflow-y: visible;\n    -webkit-overflow-scrolling: touch;\n    scroll-snap-type: x mandatory;\n}\n\n.plan-slider-wrapper::-webkit-scrollbar {\n    height: 8px;\n}\n\n.plan-slider-wrapper::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.plan-slider-wrapper::-webkit-scrollbar-thumb {\n    background: #c4c4c4;\n    border-radius: 4px;\n}\n\n.plan-slider-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #a0a0a0;\n}\n\n@media (max-width: 480px) {\n    .plan-slider-wrapper::-webkit-scrollbar {\n        height: 0;\n    }\n}\n\n.plan-slider {\n    display: flex;\n    gap: var(--sp-3);\n    width: max-content;\n}\n\n.plan-card {\n    flex: 0 0 280px;\n    min-width: 280px;\n    scroll-snap-align: center;\n    background: #ffffff;\n    border: 2px solid #bdb4f1;\n    border-radius: var(--r-m);\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    padding: var(--sp-3) var(--sp-3);\n    transition: transform 0.3s, box-shadow 0.3s;\n    box-shadow: none;\n    margin-bottom: 10px;\n    position: relative;\n}\n\n.plan-badge {\n    position: absolute;\n    top: -14px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #5616ea;\n    color: #ffffff;\n    padding: 6px 12px;\n    font-size: 0.90rem;\n    font-weight: 600;\n    line-height: 1;\n    border-radius: 16px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n    white-space: nowrap;\n}\n\n.plan-card h3 {\n    margin: 0 0 var(--sp-2);\n    font-size: clamp(1.25rem, 1vw + 1rem, 1.7rem);\n    color: var(--c-primary);\n}\n\n.plan-price {\n    font-weight: 700;\n    margin: 0px;\n    font-size: 1.5rem;\n}\n\n.plan-price-month {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #555;\n  font-style: italic;\n}\n\n.plan-description {\n    margin: 0;\n    font-size: 0.95rem;\n    color: var(--c-grey-600);\n    font-style: italic;\n    color: #5616ea;\n    margin-bottom: 5px;\n    font-weight: 600;\n}\n\n.plan-features {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 0.2rem;\n}\n\n.plan-features li {\n    font-size: 1rem;\n    margin-bottom: 0.8rem;\n    color: #333;\n}\n\n.plan-features svg {\n    margin-bottom: -0.5px;\n}\n\n.plan-icons-included {\n    margin-right: 0.5rem;\n    color: #5616ea;\n}\n\n.plan-icons-not-included {\n    margin-right: 0.5rem;\n    color: #e51616;\n}\n\n.feature-platform-icon {\n    height: 18px;\n    width: auto;\n    margin-left: 10px;\n    vertical-align: middle;\n    position: relative;\n    top: 1px;\n    object-fit: contain;\n}\n\n/* ─── Custom Tooltip Styles ──────────────────────────────────────────*/\n.icon-tooltip-wrapper {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.icon-tooltip-wrapper .feature-platform-icon {\n    transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.icon-tooltip-wrapper:hover .feature-platform-icon {\n    transform: scale(1.15) translateY(-2px);\n    filter: drop-shadow(0 4px 8px rgba(86, 22, 234, 0.25));\n}\n\n.icon-tooltip {\n    position: absolute;\n    bottom: calc(100% + 12px);\n    left: 50%;\n    transform: translateX(-50%) translateY(8px);\n    padding: 10px 14px;\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n    color: #ffffff;\n    font-size: 0.8rem;\n    font-weight: 500;\n    white-space: nowrap;\n    border-radius: 10px;\n    box-shadow: \n        0 10px 40px rgba(0, 0, 0, 0.25),\n        0 0 0 1px rgba(255, 255, 255, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    opacity: 0;\n    visibility: hidden;\n    transition: \n        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        visibility 0.3s;\n    z-index: 100;\n    pointer-events: none;\n    backdrop-filter: blur(10px);\n    letter-spacing: 0.3px;\n}\n\n.icon-tooltip::before {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 12px;\n    height: 12px;\n    background: linear-gradient(135deg, transparent 50%, #16213e 50%);\n    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);\n    border-radius: 0 0 3px 0;\n}\n\n.icon-tooltip-wrapper:hover .icon-tooltip {\n    opacity: 1;\n    visibility: visible;\n    transform: translateX(-50%) translateY(0);\n}\n\n/* Tooltip color variants */\n.icon-tooltip.facebook {\n    background: linear-gradient(135deg, #1877f2 0%, #0d65d9 100%);\n}\n.icon-tooltip.facebook::before {\n    background: linear-gradient(135deg, transparent 50%, #0d65d9 50%);\n}\n\n.icon-tooltip.instagram {\n    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n}\n.icon-tooltip.instagram::before {\n    background: linear-gradient(135deg, transparent 50%, #bc1888 50%);\n}\n\n.icon-tooltip.whatsapp {\n    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\n}\n.icon-tooltip.whatsapp::before {\n    background: linear-gradient(135deg, transparent 50%, #128c7e 50%);\n}\n\n.icon-tooltip.google-drive {\n    background: linear-gradient(135deg, #4285f4 0%, #34a853 50%, #fbbc05 100%);\n}\n.icon-tooltip.google-drive::before {\n    background: linear-gradient(135deg, transparent 50%, #fbbc05 50%);\n}\n\n.icon-tooltip.onedrive {\n    background: linear-gradient(135deg, #0078d4 0%, #005a9e 100%);\n}\n.icon-tooltip.onedrive::before {\n    background: linear-gradient(135deg, transparent 50%, #005a9e 50%);\n}\n\n.wix-plan-button {\n    width: 100%;\n    gap: 0.5em;\n    padding: 0.65em 1.5em;\n    font-weight: 600;\n    font-size: 18px;\n    border-radius: 12px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);\n    color: #fff;\n    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    text-align: center;\n    position: relative;\n    z-index: 1;\n}\n\n.wix-plan-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 12px;\n    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);\n    opacity: 0;\n    transition: opacity 0.4s ease;\n    z-index: -1;\n    pointer-events: none;\n}\n\n.wix-plan-button:hover:not(:disabled)::before {\n    opacity: 1;\n}\n\n.wix-plan-button:hover:not(:disabled) {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);\n}\n\n.wix-plan-button:disabled {\n    background: #7e868e;\n    cursor: not-allowed;\n}\n\n.pricing-indicators {\n    display: flex;\n    justify-content: center;\n    gap: var(--sp-2);\n    margin-top: var(--sp-4);\n}\n\n.indicator {\n    width: 40px;\n    height: 8px;\n    border: 1px solid var(--c-grey-300);\n    border-radius: var(--r-s);\n    background: transparent;\n    transition: background 0.3s, border-color 0.3s;\n}\n\n.indicator.active {\n    background: var(--c-primary);\n    border-color: var(--c-primary);\n}\n\n.wf-pricing-indicators {\n    display: flex;\n    justify-content: center;\n    gap: var(--sp-2);\n    margin-top: var(--sp-4);\n}\n\n.wf-indicator {\n    width: 40px;\n    height: 8px;\n    border: 1px solid var(--c-grey-300);\n    border-radius: var(--r-s);\n    background: transparent;\n    transition: background 0.3s, border-color 0.3s;\n    cursor: pointer;\n}\n\n.wf-indicator.active {\n    background: var(--c-primary);\n    border-color: var(--c-primary);\n}\n\n@media (min-width: 920px) {\n    .wf-pricing-indicators {\n        display: none;\n    }\n}\n\n.cancel-note {\n    font-size: 0.85rem;\n    color: var(--c-grey-600);\n    margin-top: 15px;\n    padding-inline: var(--sp-2);\n}\n\n.billing-toggle {\n  position: relative;\n  display: inline-flex;\n  border: 1px solid #dddddd;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f1f1f1;\n  padding: 4px;\n  outline: none;\n}\n\n.billing-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: calc(50% - 3px);\n  height: calc(100% - 6px);\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.billing-toggle[data-cycle=\"YEAR\"] .billing-thumb {\n  left: 50%;\n}\n\n.billing-toggle button {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  padding: 5px 20px;\n  padding-top: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #969696;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  outline: none;\n  text-align: center;\n}\n\n.billing-toggle button.active {\n  color: #2f2f2f;\n}\n\n@media (min-width: 920px) {\n    .plan-slider-wrapper {\n        overflow: visible;\n        padding: 0;\n        padding-top: 18px;\n    }\n\n    .plan-slider {\n        display: grid;\n        width: 100%;\n        grid-template-columns: repeat(3, 1fr);\n        gap: var(--sp-4);\n    }\n\n    .plan-card {\n        flex: 0 0 auto;\n        min-width: unset;\n        max-width: 100%;\n        scroll-snap-align: unset;\n    }\n\n    .pricing-indicators {\n        display: none;\n    }\n}\n\n.complete-title {\n    border-bottom: 1px solid var(--c-grey-300);\n    padding-bottom: 20px;\n    font-size: 1.5rem;\n}\n\n.live-highlight {\n    background: var(--c-primary);\n    color: #ffffff;\n    border-radius: 1rem;\n    font: 600 clamp(1rem, 3vw + 0.4rem, 1.4rem) / 1 inherit;\n    padding: 12px;\n    padding-top: 3px;\n    padding-bottom: 8px;\n}\n\n.portal-button-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.divider {\n  width: 0.5px;\n  background-color: #ccc;\n}\n\n.custom-url-input {\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 1rem;\n  font-weight: 600;\n  border: 1px solid #7b7b7b;\n  border-radius: 8px;\n  outline: none;\n  box-sizing: border-box;\n  background-color: white;\n  color: #333;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.custom-url-input:focus {\n  border-color: #5616ea;\n  box-shadow: 0 0 0 3px rgba(94, 27, 255, 0.15);\n}\n\n.custom-url-input:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.url-arrow-down {\n    font-size: 30px;\n    margin-bottom: 15px;\n    color: #5616ea;\n}\n\n.color-picker-container {\n    justify-content: space-between;\n}\n\n.border-radius-container {\n    justify-content: space-between;\n}\n\n.onboarding-widget-close-button {\n  font-size: 0.9375rem;\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.onboarding-widget-close-button:hover {\n  transform: translateY(-1px);\n}\n\n.onboarding-send-message {\n  padding: 10px !important;\n  padding-left: 13px !important;\n  padding-right: 13px !important;\n  margin-left: 5px !important;\n}\n\n.message-container .bot-message {\n    text-align: left;\n}\n\n.chat-body {\n    text-align: left;\n}\n\n.after-setup-links {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.integration-complete-content {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    font-size: 1.125rem;\n    font-weight: 600;\n    align-items: center;\n}\n\n/* ─── reusable back arrow ──────────────────────────────────────────*/\n.header-back-button {\n  position: relative;\n  text-align: center;\n  margin-bottom: 15px;\n  /* Room for the back button on both sides: a long title stays centred and\n     never runs under it on a phone. */\n  padding-inline: 38px;\n}\n\n.lp-back-btn {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);\n  border: none;\n  outline: none;\n  border-radius: 50%;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0,0,0,.12);\n  transition: transform .25s, box-shadow .25s;\n}\n\n.lp-back-btn:hover {\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 16px rgba(0,0,0,.16);\n}\n\n.lp-back-btn:active {\n  transform: translateY(-50%) translateX(0);\n  box-shadow: 0 3px 8px rgba(0,0,0,.12);\n}\n\n.header-back-button h2 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n\n.select {\n  padding: 10px 30px 10px 10px;\n  border: 2px solid #ccc;\n  border-radius: 6px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  background-color: #fff;\n  color: #333;\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23333' d='M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 12px;\n}\n\n.select:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n}\n\n.input-error {\n  border-color: #e74c3c;\n}\n\n.select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  color: #999;\n}\n\n.footer-cancel-info {\n    color: white;\n    margin: 0;\n    font-size: 0.75rem;\n    font-weight: 600;\n    margin-top: 5px;\n}\n\n.lawyer-footer-cancel-info {\n    color: rgb(0, 0, 0);\n    margin: 0;\n    font-size: 0.75rem;\n    font-weight: 600;\n    margin-top: -4px;\n}\n\n.chatbot-loading-container {\n    display: flex;\n    flex-direction: column;\n    color: #5616ea;\n    font-weight: 600;\n    font-size: 1.1rem;\n    margin-top: 10px;\n}\n\n.wix-price-month-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.wix-plan-price {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n}\n\n.wix-plan-month {\n    margin: 0;\n    font-size: 13px;\n    color: grey;\n    margin-top: 2px;\n    font-style: italic;\n}\n\n@media (max-width: 480px) {\n    .preview-card {\n        flex-direction: column;\n    }\n\n    .wrapper {\n        padding: var(--safe-top) var(--sp-3) var(--safe-bottom);\n    }\n\n    .card {\n        padding: var(--sp-3) var(--sp-3);\n    }\n\n    .chatbot-card {\n        padding: var(--sp-3) var(--sp-2);\n    }\n\n    .preview-parent-container {\n        padding: var(--sp-3) var(--sp-2);\n    }\n\n    .plan-card {\n        flex: 0 0 260px;\n        min-width: 260px;\n    }\n\n    .plan-card p {\n        margin: 2px;\n    }\n\n    .plan-card h3 {\n        margin: 0;\n        font-size: 1.5rem;\n    }\n\n    .plan-card:hover {\n        transform: translateY(0px);\n        box-shadow: none !important;\n    }\n\n    .cancel-note {\n        margin: 0;\n        margin-top: 20px;\n    }\n\n    .divider {\n        width: 100%;\n        height: 1px;\n        background-color: #ccc;\n    }\n\n    .btn {\n        max-width: 450px;\n        font-size: 1.1875rem;\n        padding-top: 12px;\n        padding-bottom: 12px;\n    }\n\n    .live-highlight {\n        padding: 0.25em 0.6em;\n    }\n\n    .header-back-button {\n        margin-bottom: 18px;\n    }\n\n    .landing-footer-links {\n        gap: 20px;\n        bottom: 14px;\n    }\n\n    .landing-footer-links a {\n        font-size: 0.75rem;\n    }\n    .card-button-wrapper,\n    .chatbot-card,\n    .preview-parent-container,\n    .subscription-section {\n        max-height: calc(100svh - var(--safe-top) - 2 * var(--sp-3));\n        max-height: calc(100svh - var(--safe-top) - var(--safe-bottom) - 2 * var(--sp-3));\n    }\n\n    .logo-register-site {\n        width: clamp(80px, 2vw, 50px);\n    }\n\n}\n\n.trust-slide{\n  text-align:center;\n  display:flex;\n  flex-direction:column;\n  gap:18px;\n}\n\n.trust-slide h2 {\n  font-size: 26px;\n}\n\n.carousel{\n  position:relative;\n  overflow:hidden;\n  touch-action: pan-y;\n  user-select:none;\n  -webkit-user-select:none;\n}\n\n.carousel-track{\n  display:flex;\n  transition:transform .6s ease;\n  align-items:stretch;\n}\n\n.slide{\n  flex:0 0 100%;\n  display:flex;\n}\n\n.slide-content.review-card{\n  margin: 10px 44px;\n  flex:1 1 auto;\n  display:flex;\n  flex-direction:column;\n  gap:15px;\n  background:#f8f8f8;\n  border:1px solid #5616ea;\n  border-radius:10px;\n  padding:20px 24px 16px;\n  box-shadow: 2px 2px 10px rgba(63, 2, 99, 0.2);\n}\n\n.review-text{\n  font-style:italic;\n  font-size:1.1rem;\n  line-height:1.45;\n  color:#1a1a1a;\n  margin: 0;\n}\n\n.review-footer{\n  margin-top:auto;\n  display:flex;\n  flex-direction:column;\n  align-items: center;\n  gap:10px;\n}\n\n.review-author{\n  font-weight:600;\n  font-size:.9rem;\n  color:#000;\n  line-height:1.35;\n  margin: 0;\n  margin-bottom: 0.2rem;\n}\n\n.live-btn{\n  background:#5616ea;\n  color:#fff;\n  padding:7px 16px;\n  font-size:.90rem;\n  font-weight:500;\n  border-radius:6px;\n  text-decoration:none;\n  transition:background .2s ease, transform .2s ease;\n  margin: 0;\n  text-align: center;\n  outline: none;\n  cursor: pointer;\n  border: none;\n}\n\n.live-btn:hover{\n  background:#4b16d1;\n  transform:translateY(-1px);\n}\n\n.carousel-nav{\n  position:absolute;\n  top:50%;\n  transform:translateY(-50%);\n  width:36px;\n  height:36px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  background:#fff;\n  border:1px solid rgba(0,0,0,.2);\n  border-radius:50%;\n  box-shadow:0 1px 3px rgba(0,0,0,.07);\n  color:#5616ea;\n  cursor:pointer;\n}\n\n.carousel-nav.prev{\n  left:0;\n}\n\n.carousel-nav.next{\n  right:0;\n}\n\n.carousel-dots{\n  display:flex;\n  justify-content:center;\n  gap:6px;\n}\n\n.dot{\n  width:8px;\n  height:8px;\n  border-radius:50%;\n  background:#d6d6ff;\n  cursor:pointer;\n}\n\n.dot.active{\n  background:#5616ea;\n}\n\n.trust-extras{\n  display:flex;\n  justify-content:center;\n  margin: 0.5rem;\n}\n\n.badges-wrapper{\n  display:flex;\n}\n\n.badges{\n  list-style:none;\n  display:flex;\n  flex-direction:column;\n  gap:6px;\n  padding:0;\n  margin:0;\n  font-size:.92rem;\n}\n\n.badges li{\n  display:flex;\n  align-items:center;\n  gap:8px;\n}\n\n.rating-stars {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    font-size: 9px;\n    color: #5616ea;\n}\n\n.yearly-crossout{\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.yearly-crossout .old-price {\n  text-decoration: line-through;\n  text-decoration-thickness: 1.5px;\n  text-decoration-color: #5616ea;\n  opacity: .8;\n  font-size: 18px;\n}\n\n.yearly-crossout .arrow{\n  opacity: .6;\n}\n\n.yearly-crossout .new-price{\n  font-weight:800;\n}\n\n.yearly-crossout .deal-tag {\n  display: flex;\n  align-items: center;\n  padding: 7px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  font-size: .75rem;\n  font-weight: 700;\n  border-radius: 10px;\n  background: #5616ea;\n  color: white;\n  border: none;\n  text-align: center;\n  height: 80%;\n}\n\n.free-plan-link {\n    margin: 0;\n}\n\n.free-plan-link-button {\n  background: none;\n  border: none;\n  color: #5616ea;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.85rem;\n  text-decoration: underline;\n  margin: 0;\n}\n\n.free-plan-link-button:hover {\n  opacity: 0.8;\n}\n\n\n@media(max-width:480px){\n  .slide-content.review-card{ margin-bottom:12px 40px; }\n  .carousel-nav{ width:32px; height:32px; }\n  .review-text{ font-size:1.0rem; }\n  .review-author{ font-size:.82rem; }\n  .live-btn{ font-size:.78rem; padding:6px 14px; }\n}\n\n/* ── Price cross-fade + slide (slower + staggered) ─────────────────── */\n.price-swap {\n  position: relative;\n  min-height: 60px; /* a touch taller to avoid jumps; tweak if needed */\n  will-change: opacity, transform;\n}\n\n.price-swap .pane {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transform: translateY(8px);\n  transition:\n    opacity var(--swap-dur-out) cubic-bezier(.22,.7,.18,1),\n    transform var(--swap-dur-out) cubic-bezier(.22,.7,.18,1);\n  pointer-events: none;\n}\n\n.price-swap .pane.show {\n  opacity: 1;\n  transform: translateY(0);\n  transition:\n    opacity var(--swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--swap-delay-in),\n    transform var(--swap-dur-in) cubic-bezier(.22,.7,.18,1) var(--swap-delay-in);\n  pointer-events: auto;\n}\n\n/* Deal tag pops in a hair after the content starts */\n.price-swap .pane .deal-tag {\n  transform: scale(.94);\n  opacity: 0;\n  transition:\n    transform 260ms cubic-bezier(.22,.7,.18,1) calc(var(--swap-delay-in) + 80ms),\n    opacity 260ms cubic-bezier(.22,.7,.18,1)   calc(var(--swap-delay-in) + 80ms);\n}\n\n.price-swap .pane.show .deal-tag {\n  transform: scale(1);\n  opacity: 1;\n}\n\n/* Old price fades in gently */\n.price-swap .pane .old-price {\n  opacity: 0;\n  transition: opacity 280ms ease calc(var(--swap-delay-in) + 60ms);\n}\n.price-swap .pane.show .old-price {\n  opacity: .9;\n}\n\n.start-website-hint-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 12px;\n  margin-top: 0.5rem;\n  color: #5616ea;\n  font-weight: 600;\n}\n\n.start-website-hint-text p {\n  margin: 0;\n  padding: 0;\n}\n\n\n/* Respect reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .price-swap .pane,\n  .price-swap .pane.show,\n  .price-swap .pane .deal-tag,\n  .price-swap .pane .old-price {\n    transition: none !important;\n    transform: none !important;\n    opacity: 1 !important;\n  }\n}\n\n/* Webflow onboarding: \"Add to my site\" is its own step (#1197336), a card like\n   Welcome and Create, then the publish notice inside it. */\n.card.wf-add-step {\n    width: min(100%, 520px);\n    box-sizing: border-box;\n}\n.wf-add-step .sub {\n    margin-bottom: var(--sp-3);\n}\n.wf-add-step__site {\n    width: fit-content;\n    max-width: 100%;\n    margin: 0 auto var(--sp-4);\n    padding: 6px 14px;\n    border-radius: 999px;\n    background: #f3effe;\n    color: #2b2140;\n    font-size: 14px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n}\n/* An action inside the card, not the wizard's Continue: the back button's\n   deep purple, compact. */\n.wf-add-step__btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 0 auto;\n    padding: 10px 22px;\n    border: none;\n    border-radius: 10px;\n    background-image: linear-gradient(135deg, #3d0d9d 0%, #5616ea 100%);\n    color: #fff;\n    font: inherit;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .12);\n    transition: transform .25s, box-shadow .25s;\n}\n.wf-add-step__btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, .16);\n}\n.wf-add-step__btn:disabled {\n    opacity: .6;\n    cursor: default;\n}\n.wf-add-step__done {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 0 0 var(--sp-3);\n    color: #1f9d55;\n    font-weight: 600;\n}\n.wf-add-step .wf-publish-notice {\n    margin: 0;\n    max-width: none;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
